import SchemaFormAutoSubmit from "@/components/Schema/SchemaFormAutoSubmit";
import { PageHeader } from "@ant-design/pro-components";
import { createForm } from "@formily/core";
import { Button, Tabs } from "antd";
import { useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MMNavigationRoutes from "../../utils/navigationRoutes";

const AddGovernmentIdPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const schemaIndividual = "Government ID";

  const formIndividual = useMemo(() => createForm({}), []);

  const formIndividualRef = useRef<{ handleSave: () => Promise<void> }>(null);

  return (
    <>
      <PageHeader
        className="custom-page-header"
        title={id ? "Edit Government ID" : "Add Government ID"}
        onBack={() => navigate("/mm" + MMNavigationRoutes.GOVERNMENT_ID)}
      />

      <Tabs
        items={[
          {
            key: "1",
            label: "",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formIndividual}
                  schemaName={schemaIndividual}
                  recordId={id}
                  ref={formIndividualRef}
                />
                <div className="flex justify-end gap-4">
                  <Button
                    type="primary"
                    onClick={async () => {
                      try {
                        await formIndividualRef.current?.handleSave();
                        navigate("/mm" + MMNavigationRoutes.GOVERNMENT_ID);
                      } catch (error) {
                        // Validation failed, don't redirect
                        console.log("Form validation failed:", error);
                      }
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default AddGovernmentIdPage;
